/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('schemaImporterFieldsPreview', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./schema-importer-fields-preview.html'),

      replace: true,

      scope: {
        fields: '=ngModel',
      },

      link(scope, element, attrs) {},

      controller: ['$scope', function ($scope) {}],
    };
  },
]);
